import type {
  Alert,
  Phone,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useTestNotifications } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  PopoverMenuItemIcon,
  PhoneIcon,
  useToasterContext,
} from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"

import type { TestFunctionality } from "../Contacts/TestFunctionality"
import { usePolyglot } from "src/contexts"
import {
  GenericErrorToast,
  TestPhoneCallSuccessToast,
} from "src/toasts"

const polyglotPrefix = "pages.alerts.phone_call."

export function useTestPhoneCallAlertFunctionality(
  belowNormalCall: Alert | undefined,
): TestFunctionality | undefined {
  const polyglot = usePolyglot()
  const { showToast } = useToasterContext()
  const testNotification = useTestNotifications()

  return useMemo(
    () => !belowNormalCall || !testNotification
      ? undefined
      : ({
        onClick: (phone: Phone) => {
          void (async () => {
            try {
              await testNotification(
                belowNormalCall.id,
                phone.id,
              )
              showToast(
                "test-phone-call-success-toast",
                TestPhoneCallSuccessToast,
              )
            } catch {
              showToast(
                "test-phone-call-error-toast",
                GenericErrorToast,
              )
            }
          })()
        },
        children: (
          <>
            <PopoverMenuItemIcon>
              <PhoneIcon />
            </PopoverMenuItemIcon>
            {polyglot.t(`${polyglotPrefix}test_cta`)}
          </>
        ),
      }),
    [
      polyglot,
      showToast,
      belowNormalCall,
      testNotification,
    ],
  )
}
